// this file is automatically generated by scripts/create-version-file.mjs

export const VERSION = '6481152';
